import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { AddFromSpreadsheetFormValues } from './AddProductsFromSpreadsheet';
import { GridColDef } from '@mui/x-data-grid-premium';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const BulkProductsTable = ({
  values,
  setFieldValue,
  submitForm,
  isSubmitting,
}: FormikProps<AddFromSpreadsheetFormValues>) => {
  const headers = Object.keys(values.products[0]);

  const columns: GridColDef<any>[] = headers
    .map((header) => ({
      field: header,
      headerName: header.toLocaleUpperCase(),
      flex: 1,
    }))
    .filter((col) => col.field !== 'index');

  return (
    <Stack p={5}>
      <Typography variant="h4" gutterBottom>
        Verify if your data was imported correctly
      </Typography>
      <CustomDataGrid
        rows={values.products}
        columns={columns}
        getRowId={(row) => row.index}
        onCellEditStop={({ id, row, field, api }) => {
          setFieldValue(
            `products[${row.index}][${field}]`,
            api.getRowWithUpdatedValues(id, field)[field]
          );
        }}
      />
      <Box alignSelf="flex-end">
        <Button
          variant="flat"
          onClick={() => {
            submitForm();
          }}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
        >
          {isSubmitting ? 'Adding Products...' : 'Add Products'}
        </Button>
      </Box>
      {/* <pre>{JSON.stringify(values.products, null, 1)}</pre> */}
    </Stack>
  );
};

export default BulkProductsTable;
